import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#000",
      "fill-rule": "evenodd",
      d: "M19.174 7.428v2.215h.363c1.354 0 2.463 1.094 2.463 2.428v4.644c0 1.334-1.11 2.428-2.463 2.428h-.363v1.286c0 .313-.262.571-.58.571a.58.58 0 0 1-.579-.57v-1.287H5.985v1.286c0 .313-.262.571-.58.571a.58.58 0 0 1-.579-.57v-1.287h-.363C3.11 19.143 2 18.049 2 16.715V12.07c0-1.334 1.11-2.428 2.463-2.428h.363V7.428C4.826 6.093 5.936 5 7.29 5h9.42c1.354 0 2.464 1.093 2.464 2.428m-1.279 2.847.12-.106v-2.74c0-.71-.586-1.287-1.305-1.287H7.29c-.719 0-1.305.578-1.305 1.286v2.74l.12.107a2.4 2.4 0 0 1 .822 1.796v2.215h10.146v-2.215a2.4 2.4 0 0 1 .822-1.796m1.642 7.726c.718 0 1.305-.578 1.305-1.287v-4.643c0-.708-.587-1.286-1.305-1.286-.719 0-1.305.578-1.305 1.286v3.357H5.768v-3.357c0-.708-.586-1.286-1.305-1.286-.718 0-1.305.578-1.305 1.286v4.644c0 .708.587 1.286 1.305 1.286z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }